import { render, staticRenderFns } from "./JournalOfPromotion.vue?vue&type=template&id=b5ed1900&scoped=true"
import script from "./JournalOfPromotion.vue?vue&type=script&lang=js"
export * from "./JournalOfPromotion.vue?vue&type=script&lang=js"
import style0 from "./JournalOfPromotion.vue?vue&type=style&index=0&id=b5ed1900&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ed1900",
  null
  
)

export default component.exports